import { useEffect } from 'react'

export const useImageUploaderModal = ({ open, setOpen, imageUrlArray, setImageUrlArray, pushImageUrlArray }) => {
  const cancelHandler = (formikProps) => {
    if (formikProps) {
      formikProps.resetForm()
    }
    setOpen(false)
  }

  const trimEmptyItem = (values) => {
    const trimmedArray = []
    for (let i = 0; i < values.length; i++) {
      if (values[i]) trimmedArray.push(values[i])
    }
    return trimmedArray
  }

  const saveHandler = (values) => {
    const trimmedArray = trimEmptyItem(values.values)
    pushImageUrlArray(trimmedArray)
    setOpen(false)
  }

  const formatImageUrlArray = () => {
    if (imageUrlArray.length > 0) {
      const imagesUrl = []
      for (let i = 0; i < 12; i++) {
        imagesUrl.push(imageUrlArray[i] || '')
      }
      setImageUrlArray(imagesUrl)
    } else {
      setImageUrlArray(Array(12).fill(''))
    }
  }

  const deleteImage = (values, setValues, index) => {
    const imagesArray = [...values.values]
    imagesArray.splice(index, 1)
    imagesArray[8] = ''
    setValues({ values: imagesArray })
  }

  useEffect(() => {
    formatImageUrlArray()
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [open])

  return { saveHandler, cancelHandler, deleteImage }
}
